import React from "react"
import {StyledAutocompleteContainer} from "./components"

const StandardAutocompleteContainer = ({props, children}: any) => {
    return (
        <StyledAutocompleteContainer data-testid="header-enrich-auto-complete" {...props}>
            {children}
        </StyledAutocompleteContainer>
    )
}

export default StandardAutocompleteContainer
